import { Card } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface ProcessingChartProps {
  data: { period: string; invoices_processed: number; invoices_failed: number; success_rate_pct: number }[];
  loading?: boolean;
}

export function ProcessingChart({ data, loading }: ProcessingChartProps) {
  return (
    <Card title="Processing Metrics" loading={loading}>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="period" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="left" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="right" orientation="right" domain={[0, 100]} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Line yAxisId="left" type="monotone" dataKey="invoices_processed" name="Processed" stroke="#1677ff" />
          <Line yAxisId="left" type="monotone" dataKey="invoices_failed" name="Failed" stroke="#ff4d4f" />
          <Line yAxisId="right" type="monotone" dataKey="success_rate_pct" name="Success %" stroke="#52c41a" strokeDasharray="5 5" />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
}
